import styled from "styled-components"

export const LoadingMask = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 76px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.8);
  pointer-events: all;
  transition: all 0.3s linear;

  .line {
    display: inline-block;
    width: 15px;
    height: 15px;
    margin: 6px;
    box-sizing: border-box;
    border-radius: 15px;
    background-color: #e6e6e6;
  }

  .line:nth-last-child(1) {animation: loadingC .6s .1s linear infinite;}
  .line:nth-last-child(2) {animation: loadingC .6s .2s linear infinite;}
  .line:nth-last-child(3) {animation: loadingC .6s .3s linear infinite;}
  @keyframes loadingC {
    0 {transform: translate(0,0);}
    50% {transform: translate(0,15px);}
    100% {transform: translate(0,0);}
  }
`